export default __webpack_public_path__ + "media/src/assets/images/qbReportMenu-a58a5b3779234438d73f2830a726224f.png";